import React, { useState } from "react";
import { KeyRound, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

const EMPTY = { current_password: "", new_password: "", confirm: "" };

export const ChangePasswordCard = () => {
  const [f, setF] = useState(EMPTY);
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const mismatch = f.confirm && f.confirm !== f.new_password;
  const tooShort = f.new_password && f.new_password.length < 8;

  async function submit(e) {
    e.preventDefault();
    if (mismatch || tooShort) return;
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password updated");
      setF(EMPTY);
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  }

  const field = (key, label, testid) => (
    <div>
      <label className="text-[11px] uppercase tracking-[0.16em] text-[var(--muted)]">{label}</label>
      <input data-testid={testid} type={show ? "text" : "password"} required value={f[key]} autoComplete={key === "current_password" ? "current-password" : "new-password"}
        onChange={(e) => setF({ ...f, [key]: e.target.value })} className="input-luxe" />
    </div>
  );

  return (
    <form onSubmit={submit} data-testid="change-password-card" className="bg-white border border-[var(--line)] rounded-2xl p-6 md:p-8 space-y-4">
      <div className="flex items-center justify-between">
        <p className="font-serif text-2xl flex items-center gap-2"><KeyRound className="w-5 h-5 text-[var(--gold)]" /> Change password</p>
        <button type="button" onClick={() => setShow(!show)} data-testid="change-password-toggle" className="text-[var(--muted)]">{show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}</button>
      </div>
      {field("current_password", "Current password", "change-password-current")}
      {field("new_password", "New password (8+ characters)", "change-password-new")}
      {field("confirm", "Confirm new password", "change-password-confirm")}
      {tooShort && <p className="text-xs text-red-600" data-testid="change-password-short">Use at least 8 characters.</p>}
      {mismatch && <p className="text-xs text-red-600" data-testid="change-password-mismatch">Passwords don't match.</p>}
      <button data-testid="change-password-submit" disabled={busy || mismatch || tooShort} className="btn-gold disabled:opacity-50">{busy ? "Saving…" : "Update password"}</button>
    </form>
  );
};
